import {useConstraintsQuery} from './useConstraintsQuery'

export const useGetAssetConstraint = (assetId: number) => {
  const {data: constraints} = useConstraintsQuery()

  return constraints?.assets[assetId]?.markdown
}
